module.exports = __webpack_public_path__ + "media/assets/site_images/partner_logos/tma_logo-6d9986704c92ae6b4dd4eca2a31d8ce9.png";